<template>
    <div class="main-content">
        <!-- Toasts de Notificação -->
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"> <router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Perfis de Acesso</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Perfis de Acesso</h4>
                    <span class="text-muted fs-7">Exibindo {{ roles.length }} de {{ totalItems }}</span>
                </div>

                <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3"
                                @click="confirmDelete(selectedIds.length, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{
                                    selectedIds.length ? selectedIds.length : 'perfil' }})
                            </button>
                        </div>
                    </transition>

                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <button class="btn btn-pmg-primary" data-bs-toggle="modal" data-bs-target="#modalRole"
                        @click="resetForm">
                        <i class="bi bi-shield-lock-fill me-1"></i> Novo Perfil
                    </button>
                </div>
            </div>

            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3">
                        <div class="col-md-10">
                            <input v-model="filter.name" type="text" class="form-control form-control-pmg"
                                placeholder="Filtrar por nome...">
                        </div>
                        <div class="col-md-2 d-flex">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold" @click="applyFilter">
                                <i class="bi bi-search me-1"></i> Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 30%">Nome</th>
                            <th style="width: 50%">Descrição</th>
                            <th style="width: 15%" class="text-end">Ações</th>
                        </tr>
                    </thead>

                    <tbody v-if="roles.length > 0">
                        <tr v-for="item in roles" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td>
                                <!-- Desabilita o checkbox se for o Administrador nativo -->
                                <input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds"
                                    :disabled="item.name === 'Administrador'">
                            </td>
                            <td class="fw-bold text-dark">
                                <i v-if="item.name === 'Administrador'"
                                    class="bi bi-shield-fill-check text-success me-1"
                                    title="Perfil Nativo do Sistema"></i>
                                {{ item.name }}
                            </td>
                            <td>
                                <div class="pmg-desc-cell text-truncate-custom">{{ item.description || 'Nenhuma descrição fornecida.' }}</div>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        data-bs-boundary="viewport">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0">
                                        <li><a class="dropdown-item" href="#"
                                                @click.prevent="openModal('edit', item)"><i
                                                    class="bi bi-pencil me-2"></i>Editar</a></li>

                                        <!-- NOVO: Botão de Permissões (Oculto para Administrador) -->
                                        <li v-if="item.name !== 'Administrador'">
                                            <a class="dropdown-item" href="#"
                                                @click.prevent="openPermissionsModal(item)">
                                                <i class="bi bi-ui-checks me-2"></i>Permissões
                                            </a>
                                        </li>

                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>

                                        <!-- Oculta a opção de excluir se for o Administrador -->
                                        <li v-if="item.name !== 'Administrador'">
                                            <a class="dropdown-item text-danger" href="#"
                                                @click.prevent="confirmDelete(item)">
                                                <i class="bi bi-trash me-2"></i>Excluir
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="4" class="text-center py-5 text-muted">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <i class="bi bi-inbox fs-1 mb-2 text-secondary opacity-50"></i>
                                    <span class="fw-medium">Não há registros no momento.</span>
                                    <span class="small mt-1" v-if="filter.name">Tente limpar os filtros de busca.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center mt-4" v-if="hasMore">
                <button
                    class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                    @click="loadMore" :disabled="loading" style="min-width: 220px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                    <span>{{ loading ? 'Carregando dados...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <!-- Modal Form -->
        <div class="modal fade" id="modalRole" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0">{{ isEditing ? 'Editar Perfil' : 'Novo Perfil' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeModalBtn"></button>
                    </div>
                    <div class="modal-body px-4">
                        <div class="mb-3">
                            <label class="form-label small fw-bold text-muted">Nome</label>
                            <input v-model="form.name" type="text" class="form-control form-control-pmg"
                                placeholder="Ex: Gerente Financeiro"
                                :disabled="isEditing && form.name === 'Administrador'">
                        </div>
                        <div class="mb-3">
                            <label class="form-label small fw-bold text-muted">Descrição</label>
                            <textarea v-model="form.description" class="form-control form-control-pmg" rows="3"
                                placeholder="Informe uma descrição para as responsabilidades deste perfil"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pb-4 px-4">
                        <button class="btn btn-pmg-light me-2" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" :disabled="!isFormValid" @click="saveRole">
                            {{ isEditing ? 'Atualizar' : 'Salvar Perfil' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- NOVO: Modal de Permissões -->
        <div class="modal fade" id="modalPermissions" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <div>
                            <h5 class="fw-bold m-0">Permissões do Perfil</h5>
                            <span class="text-muted small" v-if="activeRole">
                                Gerenciando acessos para: <strong class="text-dark">{{ activeRole.name }}</strong>
                            </span>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body px-4 pt-2">
                        <!-- Campo de Busca -->
                        <div class="mb-3 position-relative">
                            <i
                                class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                            <input v-model="permissionSearch" type="text" class="form-control form-control-pmg ps-5"
                                placeholder="Buscar permissão (nome ou rota)...">
                        </div>

                        <!-- Lista de Permissões -->
                        <div class="list-group list-group-flush border rounded-3 overflow-hidden">
                            <label v-for="perm in filteredPermissions" :key="perm.id"
                                class="list-group-item d-flex justify-content-between align-items-center py-3 cursor-pointer list-group-item-action">
                                <div class="me-3">
                                    <span class="fw-bold d-block text-dark" style="font-size: 0.95rem;">
                                        {{ translatePermissionName(perm.name) }}
                                    </span>
                                    <small class="text-muted d-block mb-1" style="font-size: 0.70rem; opacity: 0.7;">
                                        Nome técnico: {{ perm.name }}
                                    </small>
                                    <small class="text-muted" style="font-size: 0.75rem;">
                                        <span class="badge bg-light text-secondary border me-1">{{ perm.method }}</span>
                                        {{ perm.route_uri }}
                                    </small>
                                </div>
                                <div class="form-check form-switch m-0 fs-5">
                                    <input class="form-check-input cursor-pointer" type="checkbox" :value="perm.id"
                                        v-model="selectedPermissions">
                                </div>
                            </label>

                            <div v-if="filteredPermissions.length === 0" class="text-center py-4 text-muted">
                                <i class="bi bi-search mb-2 fs-3 opacity-50"></i>
                                <p class="mb-0 small">Nenhuma permissão encontrada.</p>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer border-0 pb-4 px-4">
                        <button class="btn btn-pmg-light me-2" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" @click="savePermissions"
                            :disabled="loadingPermissions">
                            <span v-if="loadingPermissions" class="spinner-border spinner-border-sm me-2"></span>
                            Salvar Permissões
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirm Delete -->
        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">{{ isBulkDelete ? `Excluir ${selectedIds.length} perfis
                            selecionados?` : `Excluir o perfil "${itemToDelete?.name}"?` }}</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';

export default {
    data() {
        return {
            roles: [],
            alerts: [],
            isEditing: false,
            form: { id: null, name: '', description: '' },
            selectedIds: [],
            filter: { name: '' },

            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            loading: false,
            hasMore: false,

            showFilter: false,
            modalInstance: null,
            itemToDelete: null,
            isBulkDelete: false,

            // NOVO: Variáveis para Sincronização de Permissões
            permissionsList: [],
            selectedPermissions: [],
            permissionSearch: '',
            activeRole: null,
            permissionsModalInstance: null,
            loadingPermissions: false,
            permissionDictionary: {
                'bot.knowledge.default-group': 'Conhecimento do Bot - Definir Grupo Padrão',
                'bot.knowledge.destroy': 'Excluir Conhecimento do Bot',
                'bot.knowledge.index': 'Listar Conhecimento do Bot',
                'bot.knowledge.store': 'Criar Conhecimento do Bot',
                'bot.knowledge.update': 'Atualizar Conhecimento do Bot',
                'bot.pending-questions.destroy': 'Excluir Perguntas Pendentes',
                'bot.pending-questions.index': 'Listar Perguntas Pendentes',
                'bot.pending-questions.resolve': 'Perguntas Pendentes - Resolver',
                'branches.destroy': 'Excluir Filiais',
                'branches.index': 'Listar Filiais',
                'branches.show': 'Visualizar Filiais',
                'branches.store': 'Criar Filiais',
                'branches.update': 'Atualizar Filiais',
                'capture-pages.ai-suggest': 'Páginas de Captura - Sugestão com IA',
                'capture-pages.delete-lead': 'Páginas de Captura - Excluir Lead',
                'leads.notes':'Registra uma nota interna a um lead',
                'capture-pages.destroy': 'Excluir Páginas de Captura',
                'capture-pages.index': 'Listar Páginas de Captura',
                'capture-pages.leads': 'Páginas de Captura - Acessar Leads',
                'capture-pages.reports.excel': 'Páginas de Captura - Relatório em Excel',
                'capture-pages.reports.pdf': 'Páginas de Captura - Relatório em PDF',
                'capture-pages.show': 'Visualizar Páginas de Captura',
                'capture-pages.statistics': 'Estatísticas de Páginas de Captura',
                'capture-pages.status': 'Páginas de Captura - Status',
                'capture-pages.store': 'Criar Páginas de Captura',
                'capture-pages.update': 'Atualizar Páginas de Captura',
                'capture-pages.update-custom': 'Páginas de Captura - Atualização Personalizada',
                'categories.bulk-delete': 'Excluir em Massa Categorias',
                'categories.destroy': 'Excluir Categorias',
                'categories.index': 'Listar Categorias',
                'categories.show': 'Visualizar Categorias',
                'categories.store': 'Criar Categorias',
                'categories.update': 'Atualizar Categorias',
                'clients.dashboard-stats': 'Estatísticas de Clientes',
                'clients.destroy': 'Excluir Clientes',
                'clients.documents.confirm': 'Clientes - Confirmar Documentos',
                'clients.documents.destroy': 'Excluir Documentos de Clientes',
                'clients.documents.download': 'Clientes - Baixar Documentos',
                'clients.documents.upload-link': 'Clientes - Link de Upload',
                'clients.export.excel': 'Exportar Excel de Clientes',
                'clients.import': 'Clientes - Importar',
                'clients.index': 'Listar Clientes',
                'clients.occurrences.store': 'Clientes - Registrar Ocorrência',
                'clients.reanalyze': 'Clientes - Reanalisar',
                'clients.reports.general': 'Relatório Geral de Clientes',
                'clients.show': 'Visualizar Clientes',
                'clients.store': 'Criar Clientes',
                'clients.update': 'Atualizar Clientes',
                'cost-centers.bulk-delete': 'Excluir em Massa Centros de Custo',
                'cost-centers.destroy': 'Excluir Centros de Custo',
                'cost-centers.index': 'Listar Centros de Custo',
                'cost-centers.show': 'Visualizar Centros de Custo',
                'cost-centers.store': 'Criar Centros de Custo',
                'cost-centers.update': 'Atualizar Centros de Custo',
                'crm-reasons.index': 'Listar Motivos CRM',
                'crm-tickets.destroy': 'Excluir Atendimentos CRM',
                'crm-tickets.index': 'Listar Atendimentos CRM',
                'crm-tickets.notes': 'Atendimentos CRM - Anotações',
                'crm-tickets.report.excel': 'Atendimentos CRM - Relatório Excel',
                'crm-tickets.report.pdf': 'Atendimentos CRM - Relatório PDF',
                'crm-tickets.show': 'Visualizar Atendimentos CRM',
                'crm-tickets.stats': 'Estatísticas de Atendimentos CRM',
                'crm-tickets.store': 'Criar Atendimentos CRM',
                'crm-tickets.update': 'Atualizar Atendimentos CRM',
                'dashboard.charts': 'Dashboard - Gráficos',
                'dashboard.index': 'Visualizar Dashboard',
                'documents.destroy': 'Excluir Documentos',
                'documents.download': 'Documentos - Baixar',
                'email-templates.destroy': 'Excluir Templates de E-mail',
                'email-templates.index': 'Listar Templates de E-mail',
                'email-templates.preview': 'Templates de E-mail - Pré-visualizar',
                'email-templates.show': 'Visualizar Templates de E-mail',
                'email-templates.store': 'Criar Templates de E-mail',
                'email-templates.update': 'Atualizar Templates de E-mail',
                'events.destroy': 'Excluir Eventos',
                'events.index': 'Listar Eventos',
                'events.show': 'Visualizar Eventos',
                'events.store': 'Criar Eventos',
                'events.sync': 'Eventos - Sincronizar',
                'events.update': 'Atualizar Eventos',
                'external.cnpj': 'Consultas Externas - Buscar CNPJ',
                'financial-analytics.dashboard': 'Acessar Dashboard Financeiro',
                'inventories.adjust': 'Estoques - Ajustar',
                'inventories.adjust-item': 'Estoques - Ajustar Item',
                'inventories.export': 'Exportar Estoques',
                'inventories.index': 'Listar Estoques',
                'inventories.show': 'Visualizar Estoques',
                'inventories.store': 'Criar Estoques',
                'inventories.sync': 'Estoques - Sincronizar',
                'knowledge-base-groups.destroy': 'Excluir Grupos da Base de Conhecimento',
                'knowledge-base-groups.index': 'Listar Grupos da Base de Conhecimento',
                'knowledge-base-groups.store': 'Criar Grupos da Base de Conhecimento',
                'knowledge-base-groups.update': 'Atualizar Grupos da Base de Conhecimento',
                'lead-reasons.index': 'Listar Motivos de Lead',
                'leads.update': 'Atualizar Leads',
                'payment-gateways.configure-webhook': 'Gateways de Pagamento - Configurar Webhook',
                'payment-gateways.destroy': 'Excluir Gateways de Pagamento',
                'payment-gateways.index': 'Listar Gateways de Pagamento',
                'payment-gateways.options': 'Visualizar Opções Gateways de Pagamento',
                'payment-gateways.store': 'Criar Gateways de Pagamento',
                'payment-gateways.toggle': 'Gateways de Pagamento - Ativar/Desativar',
                'payment-gateways.update': 'Atualizar Gateways de Pagamento',
                'products.audit': 'Produtos - Auditoria',
                'products.bulk-delete': 'Excluir em Massa Produtos',
                'products.destroy': 'Excluir Produtos',
                'products.export.excel': 'Exportar Excel de Produtos',
                'products.export.pdf': 'Exportar PDF de Produtos',
                'products.import': 'Produtos - Importar',
                'products.index': 'Listar Produtos',
                'products.show': 'Visualizar Produtos',
                'products.stock-movements.export': 'Produtos - Exportar Movimentações',
                'products.store': 'Criar Produtos',
                'products.update': 'Atualizar Produtos',
                'stock-movements.':'Exportar extrato de produtos',
                'quotes.destroy': 'Excluir Orçamentos',
                'quotes.index': 'Listar Orçamentos',
                'quotes.print': 'Orçamentos - Imprimir',
                'quotes.report.general': 'Relatório Geral de Orçamentos',
                'quotes.show': 'Visualizar Orçamentos',
                'quotes.store': 'Criar Orçamentos',
                'quotes.update': 'Atualizar Orçamentos',
                'reports.dre': 'Relatórios - DRE',
                'reports.stock-movements.excel': 'Relatórios - Excel de Movimentações',
                'reports.stock-movements.import': 'Relatórios - Importar Movimentações',
                'reports.stock-movements.index': 'Relatórios - Listar Movimentações',
                'roles.destroy': 'Excluir Perfis de Acesso',
                'roles.index': 'Listar Perfis de Acesso',
                'roles.permissions.update': 'Perfis de Acesso - Gerenciar Permissões',
                'roles.show': 'Visualizar Perfis de Acesso',
                'roles.store': 'Criar Perfis de Acesso',
                'roles.update': 'Atualizar Perfis de Acesso',
                'services.bulk-delete': 'Excluir em Massa Serviços',
                'services.destroy': 'Excluir Serviços',
                'services.index': 'Listar Serviços',
                'services.show': 'Visualizar Serviços',
                'services.store': 'Criar Serviços',
                'services.update': 'Atualizar Serviços',
                'stock-movements.export': 'Exportar Movimentações de Estoque de Produtos',
                'stock-movements.history': 'Movimentações de Estoque de Produtos - Histórico',
                'stock-movements.store': 'Criar Movimentações de Estoque de Produtos',
                'stock-movements.transfer': 'Movimentações de Estoque de Produtos - Transferir',
                'suppliers.bulk-delete': 'Excluir em Massa Fornecedores',
                'suppliers.destroy': 'Excluir Fornecedores',
                'suppliers.export.excel': 'Exportar Excel de Fornecedores',
                'suppliers.export.pdf': 'Exportar PDF de Fornecedores',
                'suppliers.import': 'Fornecedores - Importar',
                'suppliers.index': 'Listar Fornecedores',
                'suppliers.show': 'Visualizar Fornecedores',
                'suppliers.store': 'Criar Fornecedores',
                'suppliers.update': 'Atualizar Fornecedores',
                'support.ask': 'Suporte - Enviar Dúvida',
                'support.history': 'Suporte - Histórico',
                'system-settings.defaults': 'Configurações do Sistema - Valores Padrão',
                'system-settings.index': 'Listar Configurações do Sistema',
                'system-settings.update': 'Atualizar Configurações do Sistema',
                'transactions.bulk-delete': 'Excluir em Massa Transações',
                'transactions.cancel': 'Transações - Cancelar',
                'transactions.destroy': 'Excluir Transações',
                'transactions.document': 'Transações - Ver Documento',
                'transactions.export.excel': 'Exportar Excel de Transações',
                'transactions.import': 'Transações - Importar',
                'transactions.index': 'Listar Transações',
                'transactions.report.cashflow': 'Relatório de Fluxo de Caixa',
                'transactions.show': 'Visualizar Transações',
                'transactions.simulate': 'Transações - Simular',
                'transactions.store': 'Criar Transações',
                'transactions.update': 'Atualizar Transações',
                'whatsapp.campaign.cancel': 'WhatsApp - Cancelar Campanha',
                'whatsapp.campaign.messages': 'WhatsApp - Mensagens da Campanha',
                'whatsapp.campaign.store': 'WhatsApp - Criar Campanha',
                'whatsapp.campaigns.history': 'WhatsApp - Histórico de Campanhas',
                'whatsapp.chat.conversations': 'WhatsApp - Acessar Conversas',
                'whatsapp.chat.history': 'WhatsApp - Histórico de Chat',
                'whatsapp.chat.toggle-ai': 'WhatsApp - Ativar/Desativar IA',
                'whatsapp.connect': 'WhatsApp - Conectar Aparelho',
                'whatsapp.disconnect': 'WhatsApp - Desconectar Aparelho',
                'whatsapp.metrics': 'WhatsApp - Visualizar Métricas',
                'whatsapp.send-message': 'WhatsApp - Enviar Mensagem',
                'whatsapp.status': 'WhatsApp - Visualizar Status',
                'services.move-stock':'Criar Movimentações de Estoque de Serviços',
                'services.movements': 'Movimentações de Estoque de Serviço - Histórico',
                'services.movements.export':'Serviços - Exportar Movimentações',
                'services.export':'Exportar serviços',
                'leads.attendances':'Atendimentos de um lead',
                'capture-pages.follow-ups':'Ver datas de atendimentos agendadas de um lead',
                'attendances':'Remover atendimento de um lead',
                'leads.products-services':'Vincular produtos e/ou serviços a um lead',
                'capture-pages.utm-links':'Listar, criar, atualizar e excluir um UTM ligado a um lead'
            }
        }
    },
    computed: {
        isAllSelected() {
            const deletableRoles = this.roles.filter(r => r.name !== 'Administrador');
            return deletableRoles.length > 0 && deletableRoles.every(i => this.selectedIds.includes(i.id));
        },
        isFormValid() { return this.form.name.trim() !== ''; },

        filteredPermissions() {
            if (!this.permissionSearch) return this.permissionsList;
            const term = this.permissionSearch.toLowerCase();
            return this.permissionsList.filter(p => {
                const nameMatch = p.name.toLowerCase().includes(term);
                const uriMatch = p.route_uri.toLowerCase().includes(term);

                // Busca também no texto traduzido pelo dicionário
                const translatedName = this.translatePermissionName(p.name).toLowerCase();
                const translationMatch = translatedName.includes(term);

                return nameMatch || uriMatch || translationMatch;
            });
        }
    },
    mounted() {
        // Inicializa Modal de Roles
        const modalElement = document.getElementById('modalRole');
        if (modalElement) {
            this.modalInstance = new window.bootstrap.Modal(modalElement);
        }

        // NOVO: Inicializa Modal de Permissões
        const pModalElement = document.getElementById('modalPermissions');
        if (pModalElement) {
            this.permissionsModalInstance = new window.bootstrap.Modal(pModalElement);
        }

        this.fetchRoles();
    },
    methods: {
        async fetchRoles(page = 1, append = false) {
            this.loading = true;
            try {
                const params = {
                    page: page,
                    search: this.filter.name
                };
                const response = await api.get('/roles', { params });
                const payload = response.data;
                const items = Array.isArray(payload) ? payload : (payload.data || []);

                const paginationData = payload.meta || payload;
                const { current_page, last_page, total } = paginationData;

                if (append) {
                    this.roles = [...this.roles, ...items];
                } else {
                    this.roles = items;
                }

                this.currentPage = current_page || 1;
                this.lastPage = last_page || 1;
                this.totalItems = total || items.length;
                this.hasMore = this.currentPage < this.lastPage;

            } catch (error) {
                this.showAlert('Falha ao comunicar com o servidor.', 'error');
                console.error("Erro na API:", error);
            } finally {
                this.loading = false;
            }
        },

        async openPermissionsModal(role) {
            this.activeRole = role;
            this.selectedPermissions = [];
            this.permissionSearch = '';
            this.permissionsList = []; // Limpamos a lista antiga

            // Mostra o modal enquanto carrega (pode adicionar um loading spinner se quiser)
            if (this.permissionsModalInstance) {
                this.permissionsModalInstance.show();
            }

            try {
                // Faz uma única requisição que traz a Role e o Catálogo
                const response = await api.get(`/roles/${role.id}`);
                const payload = response.data;

                // 1. Alimenta o catálogo para desenhar os checkboxes
                this.permissionsList = payload.all_permissions || [];

                // 2. Extrai os IDs das permissões da Role para marcar os checkboxes
                if (payload.role && payload.role.permissions) {
                    this.selectedPermissions = payload.role.permissions.map(p => p.id);
                }

            } catch (error) {
                console.error(error);
                this.showAlert('Erro ao carregar as permissões do perfil.', 'error');
            }
        },

        async savePermissions() {
            this.loadingPermissions = true;
            try {
                await api.put(`/roles/${this.activeRole.id}/permissions`, {
                    permissions: this.selectedPermissions
                });
                this.showAlert(`Permissões do perfil "${this.activeRole.name}" atualizadas!`);
                if (this.permissionsModalInstance) {
                    this.permissionsModalInstance.hide();
                }
            } catch (error) {
                console.error("Erro ao salvar permissões:", error);
                this.showAlert('Erro ao salvar permissões. Verifique os dados.', 'error');
            } finally {
                this.loadingPermissions = false;
            }
        },

        loadMore() {
            if (this.hasMore && !this.loading) {
                this.fetchRoles(this.currentPage + 1, true);
            }
        },

        applyFilter() {
            this.showFilter = false;
            this.selectedIds = [];
            this.fetchRoles(1, false);
        },

        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';

            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'warning') icon = 'bi-exclamation-triangle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });

            const timeout = type === 'error' ? 6000 : 4000;
            setTimeout(() => this.removeAlert(id), timeout);
        },

        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },

        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteModal'));
            modal.show();
        },

        resetForm() {
            this.isEditing = false;
            this.form = { id: null, name: '', description: '' };
        },

        async saveRole() {
            this.loading = true;

            try {
                if (this.isEditing) {
                    const response = await api.put(`/roles/${this.form.id}`, this.form);
                    const updatedRole = response.data.data || response.data;
                    const index = this.roles.findIndex(r => r.id === this.form.id);
                    if (index !== -1) {
                        this.roles[index] = updatedRole;
                        this.showAlert("Perfil atualizado com sucesso!");
                        this.resetForm();
                    }
                } else {
                    const response = await api.post('/roles', this.form);
                    const newRole = response.data.data || response.data;
                    this.roles.unshift(newRole);
                    this.totalItems++;
                    this.showAlert("Perfil criado com sucesso!");
                }

                if (this.modalInstance) {
                    this.modalInstance.hide();
                }

            } catch (e) {
                if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }
                    this.showAlert(mensagensErro, "error");
                } else {
                    const errorMsg = e.response?.data?.message || "Erro ao salvar.";
                    this.showAlert(errorMsg, "error");
                }
            } finally {
                this.loading = false;
            }
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/roles/bulk-delete', { ids: this.selectedIds });
                    this.roles = this.roles.filter(r => !this.selectedIds.includes(r.id));
                    this.totalItems -= this.selectedIds.length;
                    this.showAlert(`${this.selectedIds.length} perfis excluídos.`);
                    this.selectedIds = [];
                } else {
                    await api.delete(`/roles/${this.itemToDelete.id}`);
                    this.roles = this.roles.filter(r => r.id !== this.itemToDelete.id);
                    this.totalItems -= 1;
                    this.showAlert(`Perfil "${this.itemToDelete.name}" removido.`);
                }

            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Erro ao comunicar com o servidor para excluir.';
                this.showAlert(errorMessage, 'error');
            } finally {
                const modalElement = document.getElementById('confirmDeleteModal');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
            }
        },

        toggleAll(e) {
            if (e.target.checked) {
                this.selectedIds = this.roles
                    .filter(r => r.name !== 'Administrador')
                    .map(r => r.id);
            } else {
                this.selectedIds = [];
            }
        },

        openModal(mode, item = null) {
            this.resetForm();
            if (mode === 'edit') {
                this.isEditing = true;
                this.form = { ...item };
            }
            if (this.modalInstance) {
                this.modalInstance.show();
            }
        },
        translatePermissionName(name) {
            // 1. Tenta encontrar a tradução exata no dicionário
            if (this.permissionDictionary[name]) {
                return this.permissionDictionary[name];
            }

            // 2. Fallback Inteligente: Se não estiver no dicionário, tenta deduzir pelo final do nome
            const parts = name.split('.');
            if (parts.length > 1) {
                const action = parts.pop(); // Pega a última palavra (ex: index, store)

                // Formata o nome do módulo (ex: 'bot.knowledge' vira 'Bot Knowledge')
                let moduleName = parts.join(' ').replace(/-/g, ' ');
                moduleName = moduleName.charAt(0).toUpperCase() + moduleName.slice(1);

                // Dicionário genérico de ações do Laravel
                const actionTranslations = {
                    'index': 'Listar',
                    'store': 'Criar',
                    'update': 'Atualizar',
                    'destroy': 'Excluir',
                    'show': 'Visualizar Detalhes de'
                };

                if (actionTranslations[action]) {
                    return `${actionTranslations[action]} ${moduleName}`;
                }
            }

            // 3. Se tudo falhar, retorna o nome técnico original
            return name;
        }
    }
}
</script>

<style scoped>
/* O SEU ESTILO BASE INTACTO */
.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}

.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-primary:disabled {
    opacity: 0.5;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.pmg-desc-cell {
    color: #64748b;
    font-size: 0.9rem;
    max-width: 500px;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
    animation: shake 0.4s ease-in-out;
}

.bg-warning-subtle {
    background-color: #fffbeb !important;
    color: #92400e !important;
    border-left: 5px solid #f59e0b !important;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

/* NOVO: Estilos para o Modal de Permissões */
.cursor-pointer {
    cursor: pointer;
}

.list-group-item-action:hover {
    background-color: #f8fafc;
}
</style>